const TZ = 'America/Mexico_City'

export function relativeTime(value) {
  if (!value) return 'Nunca'
  const diff = Date.now() - new Date(value).getTime()
  const min = Math.floor(diff / 60000)
  if (min < 1) return 'Ahora'
  if (min < 60) return `Hace ${min} min`
  const h = Math.floor(min / 60)
  if (h < 24) return `Hace ${h} h`
  const d = Math.floor(h / 24)
  if (d < 30) return `Hace ${d} ${d === 1 ? 'día' : 'días'}`
  const mo = Math.floor(d / 30)
  if (mo < 12) return `Hace ${mo} ${mo === 1 ? 'mes' : 'meses'}`
  const y = Math.floor(mo / 12)
  return `Hace ${y} ${y === 1 ? 'año' : 'años'}`
}

export function formatDate(value) {
  if (!value) return '—'
  return new Date(value).toLocaleDateString('es-MX', { timeZone: TZ, day: '2-digit', month: 'short', year: 'numeric' })
}

export function formatDateTime(value) {
  if (!value) return '—'
  return new Date(value).toLocaleString('es-MX', {
    timeZone: TZ, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false,
  })
}

export function formatTime(value) {
  if (!value) return '—'
  return new Date(value).toLocaleTimeString('es-MX', { timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
}

// Para <input type="date">: fecha de hoy en hora de CDMX.
export function todayInput() {
  return new Date().toLocaleDateString('en-CA', { timeZone: TZ })
}

export function toDateInput(value) {
  if (!value) return ''
  return new Date(value).toLocaleDateString('en-CA', { timeZone: TZ })
}

export function initials(name) {
  return (name || '').split(' ').filter(Boolean).map((s) => s[0]).join('').slice(0, 2).toUpperCase() || '?'
}

export const PARK_STATUS = {
  ACTIVE: { label: 'Activo', cls: 'ad-pill--green' },
  TRIAL: { label: 'Prueba', cls: 'ad-pill--blue' },
  EXPIRED: { label: 'Vencido', cls: 'ad-pill--amber' },
  SUSPENDED: { label: 'Suspendido', cls: 'ad-pill--red' },
}

export const ROLE_PILL = {
  ADMIN: 'ad-pill--navy',
  OPERATIONS: 'ad-pill--blue',
  FINANCE: 'ad-pill--green',
  MAINTENANCE_SUPERVISOR: 'ad-pill--amber',
  TECHNICIAN: 'ad-pill--gray',
  CUSTOM: 'ad-pill--purple',
  TENANT: 'ad-pill--teal',
}

export const PAYMENT_STATUS = {
  CURRENT: { label: 'Al corriente', cls: 'ad-pill--green' },
  DUE_SOON: { label: 'Por cobrar', cls: 'ad-pill--amber' },
  OVERDUE: { label: 'Vencido', cls: 'ad-pill--red' },
  TRIAL: { label: 'Prueba', cls: 'ad-pill--blue' },
  NO_PLAN: { label: 'Sin plan', cls: 'ad-pill--gray' },
  SUSPENDED: { label: 'Suspendido', cls: 'ad-pill--red' },
}

export const PAYMENT_METHODS = {
  TRANSFER: 'Transferencia',
  CARD: 'Tarjeta',
  CASH: 'Efectivo',
  OTHER: 'Otro',
}

export function money(n) {
  if (n === null || n === undefined) return '—'
  return Number(n).toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
}

export const ERROR_TEXT = {
  WHATSAPP_NOT_READY: 'WhatsApp todavía no está configurado en el servidor: faltan WHATSAPP_PROVIDER=meta, el token, el número y el ID de la cuenta de negocio en el .env del Backend.',
  ERROR_NOT_FOUND: 'No se encontró ese error.',
  INVALID_PLAN_NAME: 'El nombre del plan debe tener entre 2 y 60 caracteres.',
  INVALID_AMOUNT: 'El monto no es válido.',
  INVALID_FEATURES: 'Máximo 20 funciones, de hasta 120 caracteres cada una.',
  INVALID_LIMIT: 'Los límites deben ser números enteros mayores a 0 (o vacíos para "sin límite").',
  PLAN_NOT_FOUND: 'No se encontró el plan.',
  PLAN_ARCHIVED: 'Ese plan está archivado: restáuralo para asignarlo.',
  NEXT_BILLING_REQUIRED: 'Indica la fecha del primer cobro.',
  NO_PLAN: 'Este parque todavía no tiene un plan asignado.',
  INVALID_MONTHS: 'Los meses deben ser entre 1 y 24.',
  PAID_IN_FUTURE: 'La fecha de pago no puede ser futura.',
  INVALID_METHOD: 'Método de pago no válido.',
  CANNOT_MARK_OVERDUE: 'Solo un parque activo o en prueba se puede marcar como vencido.',
  INVALID_PERCENT: 'El descuento debe ser mayor a 0% y hasta 100%.',
  DATE_IN_PAST: 'La fecha de expiración no puede estar en el pasado.',
  NO_DISCOUNT: 'Este parque no tiene un descuento activo.',
  WRONG_PASSWORD: 'La contraseña no es correcta.',
  TOO_MANY_ATTEMPTS: 'Demasiados intentos. Espera unos minutos.',
  EMAIL_IN_USE: 'Ese correo ya tiene una cuenta en Parkos.',
  INVALID_EMAIL: 'El correo no es válido.',
  INVALID_PARK_NAME: 'El nombre del parque debe tener entre 2 y 120 caracteres.',
  ADMIN_NAME_REQUIRED: 'Escribe el nombre del administrador.',
  INVALID_DATE: 'La fecha no es válida.',
  REASON_REQUIRED: 'Escribe un motivo (mínimo 3 caracteres).',
  NAME_MISMATCH: 'El nombre no coincide con el del parque.',
  NO_ACTIVE_ADMIN: 'Este parque no tiene ningún administrador activo con quien entrar.',
  USE_REACTIVATE: 'El parque está suspendido: usa "Reactivar acceso".',
  ALREADY_SUSPENDED: 'Ya estaba suspendido.',
  NOT_SUSPENDED: 'No está suspendido.',
  ALREADY_ACTIVATED: 'Esta cuenta ya fue activada.',
  NOT_FOUND: 'No se encontró el registro.',
  NOTHING_TO_UPDATE: 'No hay cambios que guardar.',
  INVALID_NAME: 'El nombre debe tener entre 2 y 120 caracteres.',
  ONLY_STAFF: 'Solo se pueden editar cuentas del personal del parque.',
  USER_NOT_ACTIVE: 'Esta cuenta aún no se ha activado: usa "Reenviar invitación de activación".',
  LAST_ADMIN: 'No puedes suspender al único administrador del parque: agrega otro primero.',
}

export const errorText = (err, fallback = 'No se pudo completar la acción.') => {
  const base = ERROR_TEXT[err?.message] || fallback
  // Los errores 500 traen un código para encontrarlos en Sistema.
  return err?.ref ? `${base} Código de referencia: ${err.ref}` : base
}

// Estilos compartidos de tablas, pills y botones del panel (se importan como clases globales con :deep en cada vista).